export const NAMESPACE_APP_HEADER = 'front-initiator-namespace';
